import { z } from 'zod'

// this schema exists as a placeholder in case we want to push any supplemental
// data with the Export to appFormRelay.loadExport() in the future.
// originally for offline we were going to push the below now-commented keys
// so the data could be picked up by loadExportThunk and dropped into place
// in the redux store.
// but it doesn't make any difference to the form experience wether or not this
// data is re-imported from the last draft, and only newer renderers with
// the awareness of this object on the loadExportArgs would be able to load it
// anyway.
// so it probably makes more sense to just unshift this data onto successive
// draft Imports at time of Import save to local database.
const RDraftExportSupplement = z.object({
	// StatusHistory: z.array(RConceptStatusHistory),
	// CalculationErrors: z.array(z.string()),
})
export type DraftExportSupplement = z.infer<typeof RDraftExportSupplement>
